"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.k2f = exports.k2c = exports.f2k = exports.f2c = exports.c2k = exports.c2f = void 0;
var rounding_1 = require("./rounding");
var DEF_PRECISION = 2;
/* ***  FROM CELSIUS  *** */
// C -> F
var c2f = function (val, decimals) { return rounding_1.default((val * 9) / 5 + 32, decimals || DEF_PRECISION); };
exports.c2f = c2f;
// C -> K
var c2k = function (val, decimals) { return rounding_1.default(val + 273.15, decimals || DEF_PRECISION); };
exports.c2k = c2k;
/* ***  FROM FAHRENHEIT  *** */
// F -> C
var f2c = function (val, decimals) { return rounding_1.default(((val - 32) * 5) / 9, decimals || DEF_PRECISION); };
exports.f2c = f2c;
// F -> K
var f2k = function (val, decimals) { return exports.c2k(exports.f2c(val, decimals), decimals); };
exports.f2k = f2k;
/* ***  FROM KELVIN  *** */
// K -> C
var k2c = function (val, decimals) { return rounding_1.default(val - 273.15, decimals || DEF_PRECISION); };
exports.k2c = k2c;
// K -> F
var k2f = function (val, decimals) { return exports.c2f(exports.k2c(val, decimals), decimals); };
exports.k2f = k2f;
